import{a as n}from"./chunk-RAAYCPUM.js";function i(...e){return n(a,e)}function a(e,r){for(let[t,o]of Object.entries(e))r(o,t,e);return e}export{i as a};
